var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"download-area",attrs:{"id":_vm.elementId},on:{"mouseenter":function($event){_vm.isHover = true},"mouseleave":function($event){_vm.isHover = false},"drop":_vm.onDrop,"touchdrop":_vm.onDrop,"mouseup":_vm.onDrop}},[_vm._v("\n  DRAG HERE TO DOWNLOAD\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }